"use strict";

module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ./~/wix-bi-logger-client/dist/utils/log.js
// module id = 1130
// module chunks = 15 16 17 18 19